import React, { Component } from 'react';
import close_black from '../images/close-black.svg';
import axios from 'axios';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import '../styles/Language.scss';
import Modal from 'react-modal';
import { Fragment } from 'react';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import spinner from '../images/spinner.png';
import { withTranslation } from 'react-i18next';
import SuccessAlert from './SuccessAlert';
import ErrorAlert from './ErrorAlert';
import '../styles/orders.scss';





Modal.setAppElement("#root");

class Orders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            tenantLangArr: [],
            selectedTeam: "",
            validationError: "",
            tenantGuid: '',
            isModalOpen: false,
            isLoading: false,
            alert_type: '',
            alert_message: ''
        };
    }

    componentDidMount = () => {
        this.bindDropDowns();
    }

    languageOnChange = (e) => {
        this.setState({ selectedTeam: e.target.value, validationError: e.target.value === "" ? "Please select language" : "" })
    }

    bindDropDowns = async () => {

        try {
            let Url = 'https://xdlx6zl30e.execute-api.ap-south-1.amazonaws.com/dev/languageService/language';
            let response = await axios.get(Url);

            var langFromApi = response.data.dataObject.reduce(function (filtered, value) {
                if (value.Code !== 'en') {
                    var newObj = { value: value.LanguageId, display: value.Name }
                    filtered.push(newObj);
                }
                return filtered;
            }, []);
            // this.setState({
            //     data: [{ value: '', display: 'Select Language' }].concat(langFromApi)
            // });

            this.setState({ data: langFromApi, selectedTeam: langFromApi[0].value, tenantGuid: localStorage.getItem("tenantGuid") });
            // this.setState({ data: langFromApi });
            this.getTenantLanguage();
        } catch (err) {
            console.log('bindDropDowns error', err.response);
        }
    }

    clearAlertType = () => {
        setTimeout(() => {
            this.setState({ alert_type: '' });
        }, 4000);
    }

    addLanguage = async (e) => {
        e.preventDefault();
        this.clearAlertType();
        let languageArr = [];
        let tenantResult = this.props.auth.tenantResult;
        let newLangArr = [];

        try {
            if (this.state.selectedTeam === "") {
                this.setState({ alert_type: "ERROR" });
                this.setState({ alert_message: "Please select language" });
            } else {
                this.setState({ isLoading: true });
                languageArr.push(this.state.selectedTeam);

                let inputData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "languageGuid": languageArr
                }

                let Url = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/addTenantLanguage';
                const resp = await axios.post(Url, inputData);
                tenantResult.languageCount = tenantResult.languageCount + 1;

                //Insert into history table.
                let historyData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "userGuid": this.props.auth.tenantUserGuid,
                    "masterId": 1,
                    "count": 1,
                    "licenseTypeGuid": ''
                }

                let insertIntoHistoryTblUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/insertIntoHistoryTbl';
                await axios.post(insertIntoHistoryTblUrl, historyData);

                //Update Language Count in Tenant table.
                let tenantUpdateData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "companyName": tenantResult.companyName,
                    "userPoolName": tenantResult.userPoolName,
                    "identityPoolId": tenantResult.identityPoolId,
                    "clientId": tenantResult.clientId,
                    "region": tenantResult.region,
                    "isPurchase": tenantResult.isPurchase,
                    "locationCount": tenantResult.locationCount,
                    "productCount": tenantResult.productCount,
                    "webLicenseCount": tenantResult.webLicenseCount,
                    "pdaLicenseCount": tenantResult.pdaLicenseCount,
                    "userPoolId": tenantResult.userPoolId,
                    "languageCount": tenantResult.languageCount
                }

                let updateTenantUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/updateTenant';
                await axios.put(updateTenantUrl, tenantUpdateData);
                ;

                let alertMessage = resp.data.message;
                this.setState({ alert_type: 'SUCCESS' })
                this.setState({ alert_message: alertMessage })

                this.state.data.forEach((lang) => resp.data.dataObject.languageGuid.forEach((obj) => {
                    if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                        return newLangArr.push({ value: lang.value, display: lang.display, tenantGuid: tenantResult.tenantGuid });
                    }
                })
                );

                this.setState({ tenantLangArr: newLangArr });
                this.setState({ isLoading: false });
            }

        } catch (err) {
            console.log('error', err.response);
            this.setState({ isLoading: false });

            let finalMessage = err.response.data.message;
            this.setState({ alert_type: 'ERROR' })
            this.setState({ alert_message: finalMessage })
        }
        this.setState({ isModalOpen: false });
    }

    getTenantLanguage = async () => {
        let selectedLanguages = [];
        let allLanguageArr = this.state.data;
        let tenantGuid = localStorage.getItem("tenantGuid");

        let Url = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/getTenantLanguage/' + tenantGuid;
        let response = await axios.get(Url);

        if (response.data.dataObject.length > 0) {
            let selectedLangArr = response.data.dataObject[0].languageGuid;
            let tenantGuid = response.data.dataObject[0].tenantGuid;

            allLanguageArr.forEach((lang) => selectedLangArr.forEach((obj) => {
                if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                    selectedLanguages.push({ value: lang.value, display: lang.display, tenantGuid: tenantGuid });
                }
            })
            );

            this.setState({ tenantLangArr: selectedLanguages });
        }
    }

    deleteLanguage = async (e, item) => {
        try {
            e.preventDefault();
            let newLangArr = [];
            let tenantResult = this.props.auth.tenantResult;
            this.setState({ isLoading: true });
            
            let Url = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/deleteTenantLanguage/';
            let response = await axios.delete(Url, {
                params: {
                    languageGuid: item.value,
                    tenantGuid: item.tenantGuid
                }
            });
            tenantResult.languageCount = tenantResult.languageCount - 1;

            //Insert into history table.
            let historyData = {
                "tenantGuid": tenantResult.tenantGuid,
                "userGuid": this.props.auth.tenantUserGuid,
                "masterId": 1,
                "count": -1,
                "licenseTypeGuid": ''
            }

            let insertIntoHistoryTblUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/insertIntoHistoryTbl';
            await axios.post(insertIntoHistoryTblUrl, historyData);

            //Update Language Count in Tenant table.
            let tenantUpdateData = {
                "tenantGuid": tenantResult.tenantGuid,
                "companyName": tenantResult.companyName,
                "userPoolName": tenantResult.userPoolName,
                "identityPoolId": tenantResult.identityPoolId,
                "clientId": tenantResult.clientId,
                "region": tenantResult.region,
                "isPurchase": tenantResult.isPurchase,
                "locationCount": tenantResult.locationCount,
                "productCount": tenantResult.productCount,
                "webLicenseCount": tenantResult.webLicenseCount,
                "pdaLicenseCount": tenantResult.pdaLicenseCount,
                "userPoolId": tenantResult.userPoolId,
                "languageCount": tenantResult.languageCount
            }

            let updateTenantUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/updateTenant';
            await axios.put(updateTenantUrl, tenantUpdateData);

            this.state.data.forEach((lang) => response.data.dataObject.languageGuid.forEach((obj) => {
                if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                    newLangArr.push({ value: lang.value, display: lang.display, tenantGuid: tenantResult.tenantGuid });
                }
            })
            );

            this.setState({ tenantLangArr: newLangArr });
            this.setState({ isLoading: false });

        } catch (err) {
            console.log('error', err.response);
            this.setState({ isLoading: false });
        }

    }

    handleModalClose = event => {
        this.setState({ isModalOpen: false })
    }

    handleModalOpen = event => {
        this.setState({ isModalOpen: true });
    }

    render() {
        const { t } = this.props;
        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="content-sec">

                                    {
                                        this.state.alert_type === 'SUCCESS' ? (<SuccessAlert message={this.state.alert_message} />) : null
                                    }

                                    {
                                        this.state.alert_type === 'ERROR' ? (<ErrorAlert message={this.state.alert_message} />) : null
                                    }

                                    {
                                        (this.state.tenantLangArr.length > 0 || this.state.data.length > 0) ? (
                                            <Fragment>
                                                {/* <div className="primary-language">

                                                </div> */}


                                                <div className="language-contents">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br></br>
                                                    Curabitur auctor lobortis, vehicula eros vel, commodo quam in <b>Active Plan</b></div>

                                                <div className="language-text">{t('RECENT ORDER')}</div>


                                                <div className="subscription_billing_recent_orders">
                                                    <div className="display_flex space_between subscr-bill">
                                                        <p className="color-name-recent">RENEWAL</p>
                                                        <p className="color-name">08/09/2021</p>
                                                    </div>
                                                    <div className="display_flex subscr-bills">

                                                        <div className="color-name-pack width_90"><b>PACKAGE-01</b></div>
                                                        <div className="color-name-lang width_90">Languages</div>
                                                        <div className="color-name-num width_90">07</div>
                                                        <div className="color-name-lang width_90">Add-ons</div>
                                                        <div className="color-name-num width_90">05</div>
                                                        <div className="color-name-lang width_90">Lorem Ipsum</div>
                                                        <div className="color-name-num width_90">05</div>
                                                    </div>
                                                    <div className="display_flex subscr-bills ">
                                                        <p className="color-name-pack width_90"><b>2 Products</b></p>
                                                        <p className="color-name-lang width_90">Languages</p>
                                                        <p className="color-name-num width_90">07</p>
                                                        <p className="color-name-lang width_90">Add-ons</p>
                                                        <p className="color-name-num width_90">05</p>
                                                        <p className="color-name-lang width_90">Lorem Ipsum</p>
                                                        <p className="color-name-num width_90">05</p>
                                                    </div>
                                                </div>





                                                <div className="language-text-items">{t('PAST ORDERS')}  (03)</div>
                                                {/* <div className="renew-data">

                                                    <div className="display_flex">
                                                        <div className="display_flex width_150">
                                                            <img src={checkcircle} alt="" className="image-check-circle" />
                                                            <p className="lang-renew">02 Languages</p>
                                                        </div>
                                                        <div className="margin_left_15 width_120">
                                                            <p>(Japanese, Urdu)</p>
                                                        </div>
                                                        <div className="margin_left_15 width_100">
                                                            <p>+ $ 120.00</p>
                                                        </div>
                                                    </div>


                                                    <div className="display_flex">
                                                        <div className="display_flex width_150">
                                                            <img src={checkcircle} alt="" className="image-check-circle" />
                                                            <p className="lang-renew">01 Product</p>
                                                        </div>
                                                        <div className="margin_left_15 width_120">
                                                            <p>(NVOCC)</p>
                                                        </div>
                                                        <div className="margin_left_15 width_100">
                                                            <p>+ $ 120.00</p>
                                                        </div>
                                                    </div>

                                                </div> */}
                                                <div className="display_flex space_between subscription_billing_orders">
                                                    <div className="subscr-bill display_flex">
                                                        <p className="color-name">RENEWAL</p>
                                                        <p className="color-name-renew">PACKAGE-01</p>
                                                    </div>
                                                    <div className="subscr-bill">
                                                        <p className="color-name">08/09/2021</p>
                                                    </div>
                                                </div>



                                                <div className="display_flex space_between subscription_billing_orders">
                                                    <div className="subscr-bill display_flex">
                                                        <p className="color-name">RENEWAL</p>
                                                        <p className="color-name-renew">PACKAGE-01</p>
                                                    </div>
                                                    <div className="subscr-bill">
                                                        <p className="color-name">08/09/2021</p>
                                                    </div>
                                                </div>



                                                <div className="display_flex space_between subscription_billing_orders">
                                                    <div className="subscr-bill display_flex">
                                                        <p className="color-name">RENEWAL</p>
                                                        <p className="color-name-renew">PACKAGE-01</p>

                                                    </div>
                                                    <div className="subscr-bill">
                                                        <p className="color-name">08/09/2021</p>
                                                    </div>
                                                </div>



                                                <div className="bottom-button">

                                                    <button type="button" className="btn btn-secondary" onClick={() => { this.props.history.push('Summary') }}>{t('CANCEL')}</button>
                                                    <button type="button" className="btn btn-primary" onClick={() => { this.props.history.push('/Purchases') }}>{t('PROCEED')}</button>
                                                </div>
                                            </Fragment>
                                        ) : (<img src={loader} alt="" className="loader" />)
                                    }

                                    {
                                        (this.state.isLoading) ? (
                                            <img src={loader} alt="" className="loader" />
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>


                {/* <!-- Modal --> */}

                <Modal
                    isOpen={this.state.isModalOpen}
                    onRequestClose={this.handleModalClose}
                    contentLabel="My dialog"
                    // className="mymodal"
                    // overlayClassName="myoverlay"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        },
                        content: {
                            position: 'absolute',
                            top: '40px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }}
                // closeTimeoutMS={500}
                >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('Add Language')}</h5>
                                <button type="button" className="close" onClick={this.handleModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>

                            <fieldset disabled={this.state.isLoading}>
                                <form autoComplete="off" onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="icon" htmlFor="language">{t('Select Language')}</label>
                                                <select className="form-control select" value={this.state.selectedTeam} onChange={this.languageOnChange}>
                                                    {this.state.data && this.state.data.map((elmt) => <option key={elmt.value} value={elmt.value}>{elmt.display}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        {/* <div>{t('Learn more')}</div> */}
                                        <button type="button" onClick={this.handleModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                        <button type="submit" className="btn btn-primary" disabled={this.state.isLoading} onClick={this.addLanguage} >
                                            {this.state.isLoading && (
                                                <img src={spinner} alt="" className="btn-loader" />
                                            )}
                                            {t('Save')}
                                        </button>
                                    </div>
                                </form>
                            </fieldset>
                        </div>
                    </div>
                </Modal>

            </main >
        )
    }
};
export default withTranslation()(Orders)